import {
  LOAD_REQUEST_FAIL,
  LOAD_REQUEST_START,
  LOAD_REQUEST_SUCCESS,
} from "../actionTypes";
import getAPI from "@API/index";
import { AppLanguagesList } from "@Constants/enums";
import { changeAppLanguage } from "@Localization/utils";

export const getRequestData = () => {
  return {
    type: LOAD_REQUEST_START,
  };
};

const setRequestData = (customer) => {
  return {
    type: LOAD_REQUEST_SUCCESS,
    payload: customer,
  };
};

const setRequestDataFail = () => {
  return {
    type: LOAD_REQUEST_FAIL,
    payload: "Failed to get request data",
  };
};

/**
 * @var options = { dataType: 'findata' | 'consolidation', customerId, consolidationId }
 * */
export const getRequest = (id, options = {}) => {
  return (dispatch) => {
    console.log("options", options);
    dispatch(getRequestData());

    getAPI()
      .request({
        // TODO change url according to dataType
        url:
          options.dataType === "consolidation" &&
          options.customerId &&
          options.consolidationId
            ? `/api/customer/${options.customerId}/consolidation/${options.consolidationId}`
            : `/api/FinDataRequest/${id}`,
      })
      .then((response) => {
        const pageLanguage =
          response.language?.toLowerCase() || AppLanguagesList.Base;
        dispatch(setRequestData(response));

        changeAppLanguage(pageLanguage);
      })
      .catch(() => {
        dispatch(setRequestDataFail());
        // do nothing
      });
  };
};
